import { render, staticRenderFns } from "./customPageEdit.vue?vue&type=template&id=08fd9ec6&"
import script from "./customPageEdit.vue?vue&type=script&lang=js&"
export * from "./customPageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports